import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=fd6e2cf4&"
import script from "./ProductSelect.vue?vue&type=script&lang=js&"
export * from "./ProductSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports